import { getLocale } from '../../locale';
import sessionStorage from './clientStorage';
import { LabelStorageKey } from './getLabelsByStorageKey';
const setLabelsOnStorage = (storageKey, labels, locale, file) => {
    const currentLocale = locale || getLocale();
    if (currentLocale && storageKey) {
        const key = file ? `${storageKey}${currentLocale}_${file}` : `${storageKey}${currentLocale}`;
        sessionStorage.setItem(key, JSON.stringify(labels));
    }
};
const setHybrisLabelsOnStorage = (hybrisLabels, locale) => setLabelsOnStorage(LabelStorageKey.HYBRIS, hybrisLabels, locale);
const setAemLabelsOnStorage = (aemLabels, locale) => setLabelsOnStorage(LabelStorageKey.AEM, aemLabels, locale);
const setLslLabelsOnStorage = (lslLabels, name, locale, file) => {
    if (!name || !lslLabels || !Object.keys(lslLabels).length)
        return;
    setLabelsOnStorage(LabelStorageKey.LSL.replace('{name}', name), lslLabels, locale, file);
};
export { setHybrisLabelsOnStorage, setAemLabelsOnStorage, setLslLabelsOnStorage };
//# sourceMappingURL=setLabelsOnStorage.js.map